var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { E_MODAL_TASK_NAME, } from 'src/services/cases/types';
import { E_CASE_ACTION_TASK, E_CASE_DETAILS_MODAL, } from 'src/ui/views/dynamics/CaseGlobalViewPage/components/modals/constants';
import { isConfirmReassignParams, isConfirmRefusalParams, isIncompleteIdentityModal, isIncompleteIdentityParams, isIncompleteModal, isIncompleteParams, isInvalidIdentityModal, isInvalidIdentityParams, isReassignmentModal, isRedirectTask, isRefusalModal, isValidIdentityModal, isValidIdentityParams, isResendReconnectionLinkParams, isResendReconnectionLinkModal, } from 'src/redux/cases/types/guardsType';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { parseYYYYMMDDToDate } from 'src/shared/helpers/dateHelpers';
import { E_IDENTITY_STATUS } from 'src/ui/views/dynamics/CaseGlobalViewPage/sections/CaseInformation/types';
import { retrieveApplicantIndex } from 'src/redux/cases/helpers/caseHelpers';
export var parseIncompleteModal = function (options, applicants) {
    var title = options.title, documentsToRequest = options.documentsToRequest, additionalProofsToRequest = options.additionalProofsToRequest, invalidDocuments = options.invalidDocuments, nbOfMissingDocDecisions = options.nbOfMissingDocDecisions, submitButtonLabel = options.submitButtonLabel, submitActionLink = options.submitActionLink;
    var invalidDocByApplicant = applicants
        .filter(function (applicant, index) {
        return invalidDocuments.filter(function (document) { return document.applicantIndexes.indexOf(index) !== -1; }).length > 0;
    })
        .map(function (applicant, index) {
        var applicantIndex = applicants.findIndex(function (app) { return app.id === applicant.id; });
        var applicantInvalidDoc = applicantIndex !== -1
            ? invalidDocuments.filter(function (document) { return document.applicantIndexes.indexOf(applicantIndex) !== -1; })
            : [];
        return {
            applicant: applicant,
            invalidDocuments: applicantInvalidDoc.map(function (document) { return ({
                code: document.code,
                label: document.label,
                reasons: Object.entries(document.refusalReasons).map(function (_a) {
                    var reasonCode = _a[0], value = _a[1];
                    return ({
                        code: reasonCode,
                        label: value,
                        mandatory: false,
                    });
                }),
            }); }),
        };
    });
    /*** V4 ***/
    var documentsToRequestParsed = (documentsToRequest === null || documentsToRequest === void 0 ? void 0 : documentsToRequest.length) > 0
        ? [
            {
                applicant: null,
                requestedDocuments: documentsToRequest.map(function (document) { return ({
                    code: document.code,
                    label: document.label,
                    mandatory: document.forcedRequest,
                }); }),
            },
        ]
        : [];
    /*** V5 ***/
    var missingDocByApplicant = applicants
        .filter(function (applicant, index) {
        return (additionalProofsToRequest === null || additionalProofsToRequest === void 0 ? void 0 : additionalProofsToRequest.filter(function (document) { return document.applicantIndexes.indexOf(index) !== -1; }).length) > 0;
    })
        .map(function (applicant, index) {
        var applicantRequestedDoc = additionalProofsToRequest === null || additionalProofsToRequest === void 0 ? void 0 : additionalProofsToRequest.filter(function (document) { return document.applicantIndexes.indexOf(index) !== -1; });
        return {
            applicant: applicant,
            requestedDocuments: applicantRequestedDoc.map(function (document) { return ({
                code: document.id,
                label: document.label,
                mandatory: false,
            }); }),
        };
    });
    return {
        taskType: E_CASE_ACTION_TASK.MODAL,
        type: E_CASE_DETAILS_MODAL.INCOMPLETE,
        title: title,
        confirmButton: {
            label: submitButtonLabel,
            link: submitActionLink,
        },
        nbOfMissingDocDecisions: nbOfMissingDocDecisions,
        documentsToRequest: missingDocByApplicant.length > 0 ? missingDocByApplicant : documentsToRequestParsed,
        invalidDocumentsByApplicant: invalidDocByApplicant,
    };
};
export var parseReassignModal = function (i18n, teams, options) {
    var _a, _b;
    var title = options.title, agencies = options.agencies, currentAgencyCode = options.currentAgencyCode, submitActionLink = options.submitActionLink;
    return {
        taskType: E_CASE_ACTION_TASK.MODAL,
        type: E_CASE_DETAILS_MODAL.REASSIGN_CASE,
        title: title,
        confirmButton: {
            label: getPropsByKeyPath(i18n, 'modules.teamAssignment.submitButtonLabel'),
            link: submitActionLink,
        },
        teams: Object.entries(agencies).map(function (_a) {
            var key = _a[0], agency = _a[1];
            return ({
                code: key,
                label: agency.label,
            });
        }),
        currentTeam: currentAgencyCode
            ? (_a = agencies === null || agencies === void 0 ? void 0 : agencies[currentAgencyCode]) === null || _a === void 0 ? void 0 : _a.label
            : ((_b = teams === null || teams === void 0 ? void 0 : teams.find(function (team) { return team.code === currentAgencyCode; })) === null || _b === void 0 ? void 0 : _b.libelle) || null,
    };
};
export var parseRefusalModal = function (i18n, options) {
    var title = options.title, reasons = options.reasons, defaultReasonCode = options.defaultReasonCode, submitActionLink = options.submitActionLink;
    return {
        taskType: E_CASE_ACTION_TASK.MODAL,
        type: E_CASE_DETAILS_MODAL.REFUSAL_ABORT,
        title: title,
        confirmButton: {
            label: getPropsByKeyPath(i18n, 'modules.caseAbort.submitButtonLabel'),
            link: submitActionLink,
        },
        reasons: Object.entries(reasons).map(function (_a) {
            var key = _a[0], reason = _a[1];
            return ({
                code: key,
                label: reason.label,
            });
        }),
        defaultReason: reasons[defaultReasonCode].label,
    };
};
export var parseValidIdentityModal = function (i18n, options, applicants) {
    var title = options.title, identities = options.identities, submitActionLink = options.submitActionLink, submitButtonLabel = options.submitButtonLabel, acknowledgmentItems = options.acknowledgmentItems;
    return {
        taskType: E_CASE_ACTION_TASK.MODAL,
        type: E_CASE_DETAILS_MODAL.VALID_IDENTITY,
        title: title,
        applicants: applicants.filter(function (applicant) { return applicant.identityStatus === E_IDENTITY_STATUS.TO_STUDY; }),
        identities: identities.map(function (ident) { return (__assign(__assign(__assign({}, ident), { birthDate: parseYYYYMMDDToDate(ident.birthDate) }), (ident.identityDocument
            ? {
                identityDocument: __assign(__assign(__assign({}, (ident.identityDocument.documentNumber !== undefined
                    ? { documentNumber: ident.identityDocument.documentNumber }
                    : undefined)), (ident.identityDocument.expirationDate !== undefined
                    ? { expirationDate: parseYYYYMMDDToDate(ident.identityDocument.expirationDate) }
                    : undefined)), (ident.identityDocument.mrzLines !== undefined
                    ? { mrzLines: ident.identityDocument.mrzLines || [] }
                    : undefined)),
            }
            : undefined))); }),
        acknowledgmentItems: (acknowledgmentItems === null || acknowledgmentItems === void 0 ? void 0 : acknowledgmentItems.map(function (item) { return ({
            code: item.code,
            label: getPropsByKeyPath(i18n, "keyValueMap.caseGlobalView.moActions.showIdentityAcceptedModal.acknowledgments.".concat(item.code, ".label")),
            required: item.required,
        }); })) || [],
        confirmButton: {
            label: submitButtonLabel,
            link: submitActionLink,
        },
    };
};
export var parseIncompleteIdentityModal = function (i18n, options, applicants) {
    var title = options.title, submitActionLink = options.submitActionLink, submitButtonLabel = options.submitButtonLabel, identityStatusReasons = options.identityStatusReasons;
    return {
        taskType: E_CASE_ACTION_TASK.MODAL,
        type: E_CASE_DETAILS_MODAL.INCOMPLETE_IDENTITY,
        title: title,
        applicants: applicants.filter(function (applicant) { return applicant.identityStatus === E_IDENTITY_STATUS.TO_STUDY; }),
        reasons: identityStatusReasons.map(function (reason) { return ({
            code: reason,
            label: getPropsByKeyPath(i18n.keyValueMap, "caseGlobalView.infoItems.applicant.identityStatusReason.".concat(reason, ".label")) ||
                reason,
        }); }),
        confirmButton: {
            label: submitButtonLabel,
            link: submitActionLink,
        },
    };
};
export var parseInvalidIdentityModal = function (i18n, options, applicants) {
    var title = options.title, submitActionLink = options.submitActionLink, submitButtonLabel = options.submitButtonLabel, identityStatusReasons = options.identityStatusReasons;
    return {
        taskType: E_CASE_ACTION_TASK.MODAL,
        type: E_CASE_DETAILS_MODAL.INVALID_IDENTITY,
        title: title,
        applicants: applicants.filter(function (applicant) { return applicant.identityStatus === E_IDENTITY_STATUS.TO_STUDY; }),
        reasons: identityStatusReasons.map(function (reason) { return ({
            code: reason,
            label: getPropsByKeyPath(i18n.keyValueMap, "caseGlobalView.infoItems.applicant.identityStatusReason.".concat(reason, ".label")) ||
                reason,
        }); }),
        confirmButton: {
            label: submitButtonLabel,
            link: submitActionLink,
        },
    };
};
export var parseResendReconnectionLinkModal = function (i18n, options, applicants) {
    var _a = options || {}, title = _a.title, submitActionLink = _a.submitActionLink, contactChannels = _a.contactChannels;
    return {
        taskType: E_CASE_ACTION_TASK.MODAL,
        type: E_CASE_DETAILS_MODAL.RESEND_RECONNECTION_LINK,
        title: title || getPropsByKeyPath(i18n, 'modules.resendReconnectionLinkModal.title'),
        confirmButton: {
            label: getPropsByKeyPath(i18n, 'modules.resendReconnectionLinkModal.confirmButtonLabel'),
            link: submitActionLink,
        },
        applicants: applicants,
        contactChannels: contactChannels,
    };
};
export var parseRedirectTask = function (options) {
    var to = options.to, openInNewTab = options.openInNewTab;
    return {
        taskType: E_CASE_ACTION_TASK.REDIRECT,
        href: to,
        target: openInNewTab ? '_blank' : undefined,
    };
};
/**
 * purge and accept don't use returned value
 */
export var parseModalCaseAction = function (coreConfigs, modalActionData, applicants) {
    var i18n = coreConfigs.i18n, teams = coreConfigs.teams;
    var headers = modalActionData.headers, body = modalActionData.body;
    var TaskName = headers.TaskName;
    var options = body.options;
    var typeOfTask = function () {
        switch (TaskName) {
            case E_MODAL_TASK_NAME.AGENCY_ASSIGNMENT_MODAL:
            case E_MODAL_TASK_NAME.CASE_ABORT_MODAL:
            case E_MODAL_TASK_NAME.EXTERNAL_COMMENTS_MODAL:
            case E_MODAL_TASK_NAME.IDENTITY_ACCEPTED_MODAL:
            case E_MODAL_TASK_NAME.IDENTITY_INCOMPLETE_MODAL:
            case E_MODAL_TASK_NAME.IDENTITY_INVALID_MODAL:
            case E_MODAL_TASK_NAME.RESEND_RECONNECTION_LINK_MODAL:
                return E_CASE_ACTION_TASK.MODAL;
            case E_MODAL_TASK_NAME.ONE_TIME_REDIRECTION:
                return E_CASE_ACTION_TASK.REDIRECT;
            default: {
                console.error('Type of task event not handled', TaskName, modalActionData);
                return null;
            }
        }
    };
    switch (typeOfTask()) {
        case E_CASE_ACTION_TASK.MODAL: {
            var isResendReconnectionLink = TaskName === E_MODAL_TASK_NAME.RESEND_RECONNECTION_LINK_MODAL;
            var isResendReconnectionLinkParams_1 = isResendReconnectionLinkModal(options);
            if (isResendReconnectionLink && isResendReconnectionLinkParams_1) {
                return parseResendReconnectionLinkModal(i18n, options, applicants);
            }
            var isReassign = TaskName === E_MODAL_TASK_NAME.AGENCY_ASSIGNMENT_MODAL;
            var isReassignParams = isReassignmentModal(options);
            if (isReassign && isReassignParams) {
                return parseReassignModal(i18n, teams, options);
            }
            var isRefusal = TaskName === E_MODAL_TASK_NAME.CASE_ABORT_MODAL;
            var isRefusalParams = isRefusalModal(options);
            if (isRefusal && isRefusalParams) {
                return parseRefusalModal(i18n, options);
            }
            var isIncomplete = TaskName === E_MODAL_TASK_NAME.EXTERNAL_COMMENTS_MODAL;
            var isIncompleteParams_1 = isIncompleteModal(options);
            if (isIncomplete && isIncompleteParams_1) {
                return parseIncompleteModal(options, applicants);
            }
            var isValidIdentity = TaskName === E_MODAL_TASK_NAME.IDENTITY_ACCEPTED_MODAL;
            var isValidIdentityParams_1 = isValidIdentityModal(options);
            if (isValidIdentity && isValidIdentityParams_1) {
                return parseValidIdentityModal(i18n, options, applicants);
            }
            var isIncompleteIdentity = TaskName === E_MODAL_TASK_NAME.IDENTITY_INCOMPLETE_MODAL;
            var isIncompleteIdentityParams_1 = isIncompleteIdentityModal(options);
            if (isIncompleteIdentity && isIncompleteIdentityParams_1) {
                return parseIncompleteIdentityModal(i18n, options, applicants);
            }
            var isInvalidIdentity = TaskName === E_MODAL_TASK_NAME.IDENTITY_INVALID_MODAL;
            var isInvalidIdentityParams_1 = isInvalidIdentityModal(options);
            if (isInvalidIdentity && isInvalidIdentityParams_1) {
                return parseInvalidIdentityModal(i18n, options, applicants);
            }
            return null;
        }
        case E_CASE_ACTION_TASK.REDIRECT: {
            return isRedirectTask(body) ? parseRedirectTask(body) : null;
        }
        default: {
            return null;
        }
    }
};
export var parseIncompleteModalForConfirmation = function (applicants, incompleteParams) {
    var documentToRequestedArray = Object.entries(incompleteParams.documentsToRequest).reduce(function (acc, _a) {
        var applicantId = _a[0], documents = _a[1];
        var applicantIndex = retrieveApplicantIndex(applicants, applicantId);
        var accEnhanced = acc.map(function (doc) {
            var docAlreadyExist = documents.some(function (item) { return item.code === doc.id; });
            if (docAlreadyExist) {
                return __assign(__assign({}, doc), { applicantIndexes: __spreadArray(__spreadArray([], doc.applicantIndexes, true), [applicantIndex], false) });
            }
            else {
                return doc;
            }
        });
        var documentsNotIntoAcc = documents
            .filter(function (item) { return !acc.some(function (doc) { return doc.id === item.code; }); })
            .map(function (item) { return ({
            id: item.code,
            applicantIndexes: [applicantIndex],
        }); });
        return __spreadArray(__spreadArray([], accEnhanced, true), documentsNotIntoAcc, true);
    }, []);
    return {
        comments: incompleteParams.comments,
        requestedAdditionalProofs: documentToRequestedArray,
        refusalReasonCodes: incompleteParams.refusalReasonCodes,
        refusedElements: incompleteParams.refusedElements,
    };
};
export var prepareActionModalForConfirmation = function (applicants, actionModal, params) {
    var type = actionModal.type;
    switch (type) {
        case E_CASE_DETAILS_MODAL.REASSIGN_CASE: {
            return isConfirmReassignParams(params) ? { agencyCode: params.agencyCode } : null;
        }
        case E_CASE_DETAILS_MODAL.REFUSAL_ABORT: {
            return isConfirmRefusalParams(params) ? { reasonCode: params.reasonCode } : null;
        }
        case E_CASE_DETAILS_MODAL.INCOMPLETE: {
            return isIncompleteParams(params) ? parseIncompleteModalForConfirmation(applicants, params) : null;
        }
        case E_CASE_DETAILS_MODAL.VALID_IDENTITY: {
            if (isValidIdentityParams(params)) {
                var applicantId = params.applicantId, inputIdentity = params.inputIdentity, reviewedIdentity = params.reviewedIdentity, acknowledgmentItems = params.acknowledgmentItems;
                var inputIdentityApplicantId = inputIdentity.applicantId, restInputIdentity = __rest(inputIdentity, ["applicantId"]);
                var reviewedIdentityApplicantId = reviewedIdentity.applicantId, restReviewedIdentity = __rest(reviewedIdentity, ["applicantId"]);
                return __assign({ applicantId: applicantId, inputIdentity: __assign(__assign(__assign({}, restInputIdentity), (restInputIdentity.birthDate ? { birthDate: restInputIdentity.birthDate.toString() } : null)), { birthPlace: { name: restInputIdentity.birthPlace } }), reviewedIdentity: __assign(__assign(__assign({}, restReviewedIdentity), (restReviewedIdentity.birthDate ? { birthDate: restReviewedIdentity.birthDate.toString() } : null)), { birthPlace: { name: restReviewedIdentity.birthPlace } }) }, ((acknowledgmentItems === null || acknowledgmentItems === void 0 ? void 0 : acknowledgmentItems.length) ? { acknowledgmentItems: acknowledgmentItems } : {}));
            }
            return null;
        }
        case E_CASE_DETAILS_MODAL.INCOMPLETE_IDENTITY: {
            return isIncompleteIdentityParams(params)
                ? { applicantId: params.applicantId, identityStatusReason: params.reasonCode }
                : null;
        }
        case E_CASE_DETAILS_MODAL.INVALID_IDENTITY: {
            return isInvalidIdentityParams(params)
                ? { applicantId: params.applicantId, identityStatusReason: params.reasonCode }
                : null;
        }
        case E_CASE_DETAILS_MODAL.RESEND_RECONNECTION_LINK: {
            if (isResendReconnectionLinkParams(params)) {
                var contactChannels = __spreadArray(__spreadArray([], (params.sendSms ? ['SMS'] : []), true), (params.sendEmail ? ['EMAIL'] : []), true);
                return {
                    contactChannels: contactChannels,
                    applicantIds: [params.applicantId],
                };
            }
            return null;
        }
        default:
            return null;
    }
};
